import { useContext, useEffect, useState } from "react";
import { Popover, Avatar, Badge, Flex, Input } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "./style.css";
import MenuSide from "../menu";
// import ProfileCard from "../../../auth/profile-card";
import { FiBell } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../../contexts/app/context";
import AuthContext from "../../../../contexts/auth/context";
import { UserOutlined } from "@ant-design/icons";
import ProfileCard from "../../../auth/profile-card";

const NavBar = () => {
  const { screenSize } = useContext(AppContext);
  const [visible, setVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (screenSize === "laptopOrDesktop" || screenSize === "mobileOrTablet") {
      setVisible(false);
    }
  }, [screenSize]);

  // User Popover
  const [userPopoverVisible, setUserPopoverVisible] = useState(false);

  // Auth context
  const { authUser: user } = useContext(AuthContext);

  return (
    <nav className="navbar" dir="rtl">
      <Flex gap={"10px"}>
        <Input.Search placeholder="ابحث عن مستخدم" variant="filled" />
        <Input.Search placeholder="ابحث عن رقم الهاتف" variant="filled" />
      </Flex>

      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.2rem",
          }}
        >
          <span className="bell-icon-tablet">
            <Badge count={9} size="small">
              <FiBell
                color="#636e72"
                size="15"
                onClick={() => {
                  navigate("/notifications");
                }}
              />
            </Badge>
          </span>

          <Popover
            trigger="click"
            open={userPopoverVisible}
            onOpenChange={setUserPopoverVisible}
            placement="bottomRight"
            content={
              <ProfileCard toogleUserPopoverVisible={setUserPopoverVisible} />
            }
          >
            <div className={"avatarContainer"}>
              <Avatar
                size="large"
                src={
                  user?.photo?.url ?? (
                    <UserOutlined
                      style={{
                        fontSize: "1.5rem",
                        background: "#636e7281",
                        padding: "1rem",
                        borderRadius: "15px",
                      }}
                    />
                  )
                }
              />

              <div className={"username"}>
                <div dir="rtl">{`${
                  user?.EmployeeName ?? "Administrator"
                }`}</div>
                <small dir="rtl" style={{ opacity: "0.5" }}>
                  {`${user?.FullName ?? "email"}`}
                </small>
              </div>
            </div>
          </Popover>
        </div>
      </div>

      {/* <Drawer
        title={
          <Flex justify="space-between" align="center">
            <Image
              preview={false}
              src={`/images/logo.png`}
              width={60}
              alt={"logo"}
            />
            <div
              dir="rtl"
              style={{
                color: "white",
                fontSize: "1rem",
                fontWeight: "600",
              }}
            >
              Tajir
            </div>
            <div
              style={{
                color: "white",
                opacity: "0.5",
                fontSize: "0.895rem",
                fontWeight: "400",
                position: "relative",
                right: "5px",
              }}
            >
              لوحة التحكم
            </div>
          </Flex>
        }
        headerStyle={{
          backgroundColor: "rgb(33, 37, 41)",
          color: "white",
          placeItems: "flex-end",
        }}
        closable={false}
        placement="right"
        className="drawer"
        width={"17.5rem"}
        bodyStyle={{ padding: 0, backgroundColor: "rgb(33, 37, 41)" }}
        onClose={() => setVisible(false)}
        open={visible}
        footerStyle={{
          backgroundColor: "rgb(33, 37, 41)",
          color: "white",
        }}
        footer={
          <>
            <h5
              style={{
                opacity: "0.8",
              }}
            >
              Tajir
            </h5>
            <h5 style={{ opacity: "0.7" }}>الحفوق محفوظة © 2024</h5>
          </>
        }
      >
        <MenuSide />
      </Drawer> */}
    </nav>
  );
};
export default NavBar;
